import {
  apiRequest,
  pensiunUpdate,
  pensiunDetail,
  masterType,
  pensiunDocuments,
  masterBank,
} from "../../../../../services/adapters/kepegawaian/pensiunService";

class UpdateRepository {
  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      pensiunUpdate,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      pensiunDetail,
      {
        params: query,
      },
      true
    );
  };

  fetchType = async (query) => {
    return await apiRequest(
      "get",
      masterType,
      {
        params: query,
      },
      true
    );
  };

  fetchDocument = async (query) => {
    return await apiRequest(
      "get",
      pensiunDocuments,
      {
        params: query,
      },
      true
    );
  };

  fetchBank = async (query) => {
    return await apiRequest(
      "get",
      masterBank,
      {
        params: query,
      },
      true
    );
  };
}

export default UpdateRepository;
